import React from "react";
import { Table } from "../../shared";

export const RTC = () => {
  return <div>RTC</div>;
};
